import type { LoaderFunctionArgs } from 'react-router-dom'
import { getProductQuantities } from 'client/stock-transfers/stock-transfers.client'

export const productFormLoader = async ({ params }: LoaderFunctionArgs) => {
  try {
    return await getProductQuantities(params.transferId!, params.ean!)
  } catch (error) {
    console.warn(error)
    return Promise.resolve(null)
  }
}
